import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {BlogsEmLeadsRoutingModule} from './blogs-em-leads-routing.module';
import {BlogsEmLeadsComponent} from './blogs-em-leads.component';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreDirectivesModule} from '../../../@core/directives/directives';
import {ProgramRoutingModule} from '../program/program-routing.module';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';


@NgModule({
    declarations: [BlogsEmLeadsComponent],
    imports: [
        CommonModule,
        BlogsEmLeadsRoutingModule,
        NgbModule,
        CoreDirectivesModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ]
})
export class BlogsEmLeadsModule {
}
